import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		Text: null as string | null,
		ZVariaId: null as number | null,
		ZVariaZkt: null as string | null,
	},
	localState: {},
	props: {
		mode: null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
});
